import { ThunkHelper } from 'invision-core';
export var ISSUE_WRITE_OFF_CONSTANTS = {
  BEGIN: 'ISSUE_WRITE_OFF_BEGIN',
  SUCCESS: 'ISSUE_WRITE_OFF_SUCCESS',
  FAILURE: 'ISSUE_WRITE_OFF_FAILURE'
};
var ISSUE_WRITE_OFF_EVENTS = [ISSUE_WRITE_OFF_CONSTANTS.BEGIN, ISSUE_WRITE_OFF_CONSTANTS.SUCCESS, ISSUE_WRITE_OFF_CONSTANTS.FAILURE];
export var IssueWriteOff = function IssueWriteOff(data) {
  return function (dispatch) {
    return ThunkHelper(dispatch, ISSUE_WRITE_OFF_EVENTS, {
      method: 'POST',
      url: 'SubscriberManagement/ProcessWriteOff',
      data: data
    });
  };
};